import React, { Component } from 'react';
import styled from 'styled-components';
import { Grid as G, Header as H } from 'semantic-ui-react';

class HelpInfo extends Component {
  render() {
    return (
      <Container>
        <Grid columns={2} stackable>
          <VideoContainer>
            <Video autoPlay loop preload>
              <source src={this.props.presentationVideo} type="video/mp4" />
            </Video>
          </VideoContainer>
          <TextContainer>
            <Header as="h1" textAlign="center">
              {this.props.HelpInfoTitle}
            </Header>
            <Text>{this.props.HelpInfo1}</Text>
            <Text>{this.props.HelpInfo2}</Text>
          </TextContainer>
        </Grid>
      </Container>
    );
  }
}

export default HelpInfo;

const Container = styled.div`
  width: 100%;
  /* padding: 2rem 1rem !important; */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #262936;
  padding: 2rem 0;
  @media only screen and (max-width: 767px) {
    /* padding: 0.5rem !important; */
    padding: 0 !important;
  }
  /* background: linear-gradient(to top, #262936, #243b55); */
  /* background: -webkit-linear-gradient(to top, #262936, #243b55); */
`;

const Grid = styled.div`
  border-radius: 0.28571429rem;
  /* min-height: 50vh; */

  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  /* box-shadow: black 0px 10px 50px; */
  padding: 3rem 1rem !important;
  @media only screen and (max-width: 1150px) {
    flex-direction: column;
  }
  @media only screen and (max-width: 767px) {
    /* padding: 0.5rem !important; */
    padding: 0 !important;
  }
`;

const VideoContainer = styled.div`
  flex: 3;
  max-width: 500;
  @media only screen and (max-width: 1150px) {
    display: none;
  }
`;

const TextContainer = styled.div`
  padding: 0.25rem;
  flex: 2;
  margin-left: 2rem;
  @media only screen and (max-width: 1150px) {
    margin-left: 0;
  }
`;

const Video = styled.video`
  width: 100%;
  @media only screen and (max-width: 1150px) {
    display: none;
  }
`;

const Header = styled(H)`
  color: #4babc0 !important;
  font-size: 50px !important;
  line-height: 50px !important;
  margin-bottom: 3rem !important;

  width: 500px;
  @media (max-width: 1150px) {
    width: 100% !important;
    padding: 0 50px !important;
  }
  @media (max-width: 950px) {
    text-align: center !important;
    margin-top: 20px !important;
    /* margin-bottom: 10px !important; */
    font-size: 30px !important;
    line-height: 30px !important;
    width: 100% !important;
  }
  @media (max-width: 400px) {
    width: 100% !important;
    font-size: 30px !important;
    margin-top: 25px !important;
  }
`;

const Text = styled.div`
  color: rgb(102, 109, 137);
  font-size: 20px;
  letter-spacing: 1px;
  margin-bottom: 10px;
  margin-top: 20px;
  width: 500px;
  &::first-letter {
    font-size: 120%;
  }
  @media (max-width: 1150px) {
    width: 100%;
    padding: 0 50px;
  }
  @media (max-width: 950px) {
    width: 100%;
    padding: 0 30px;
  }
  @media (max-width: 400px) {
    width: 100%;
    margin-bottom: 5px;
    margin-top: 10px;
    font-size: 18px;
    padding: 0 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/HelpInfo/index.js